module.exports = "<div class=\"self-service-list hide\"> </div> ";